import axiosClient from './axiosClient';

export default {

  // 🔍 Report JSON (per visualizzazione pagina)
  get: (contribuenteId) =>
    axiosClient.get(`/report/contribuente/${contribuenteId}`),

  // 📄 Export PDF
  pdf: async (contribuenteId) => {
    const res = await axiosClient.get(
      `/report/contribuente/${contribuenteId}/pdf`,
      { responseType: 'blob' }
    );

    const blob = new Blob([res.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `report_contribuente_${contribuenteId}.pdf`;
    a.click();

    window.URL.revokeObjectURL(url);
  },

  // 📊 Export Excel
  excel: async (contribuenteId) => {
    const res = await axiosClient.get(
      `/report/contribuente/${contribuenteId}/excel`,
      { responseType: 'blob' }
    );

    const blob = new Blob([res.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `report_contribuente_${contribuenteId}.xlsx`;
    a.click();

    window.URL.revokeObjectURL(url);
  }
};